<div class="modal-header border-0">
  <button type="button" class="btn-close" (click)="modal.dismiss()">
    <i class="gpicon-close"></i>
  </button>
</div>

<div class="custom-scroll-parent gpx-8">
  <div class="modal-body custom-scroll gpx-16 gpx-sm-64 gpb-0">
    <h6 class="h6-bold modal-title w-100 gmb-24">
      {{ 'RESULTS.ADD.BODY_FAT_INSTRUCTIONS.TITLE' | translate }}
    </h6>

    <p class="p3-semibold gmb-8">
      {{ 'RESULTS.ADD.BODY_FAT_INSTRUCTIONS.SUBTITLE1' | translate }}
    </p>
    <p class="p3-regular text-secondary gmb-24">
      {{ 'RESULTS.ADD.BODY_FAT_INSTRUCTIONS.CONTENT1' | translate }}
    </p>

    <p class="p3-semibold gmb-8">
      {{ 'RESULTS.ADD.BODY_FAT_INSTRUCTIONS.SUBTITLE2' | translate }}
    </p>
    <p class="p3-regular text-secondary gmb-24">
      {{ 'RESULTS.ADD.BODY_FAT_INSTRUCTIONS.CONTENT2' | translate }}
    </p>

    <p class="p3-semibold gmb-8">
      {{ 'RESULTS.ADD.BODY_FAT_INSTRUCTIONS.SUBTITLE3' | translate }}
    </p>
    <p class="p3-regular text-secondary gmb-48 gmb-sm-56">
      {{ 'RESULTS.ADD.BODY_FAT_INSTRUCTIONS.CONTENT3' | translate }}
    </p>
  </div>
</div>
